import type { ReactNode } from "react";
import { ErrorBoundary, type FallbackRender } from "@sentry/react";
import { Button } from "@shared/components";

interface GlobalErrorBoundaryProps {
  children: ReactNode;
}

function ErrorFallback({ error, resetError }: Parameters<FallbackRender>[0]) {
  return (
    <div className="flex flex-col items-center justify-center h-screen">
      <div style={{ width: "fit-content", margin: "10px", padding: "20px" }}>
        {error instanceof Error
          ? error.message
          : "An unexpected error occurred"}
      </div>
      <Button onClick={resetError}>Try Again</Button>
      <Button onClick={() => window.location.reload()}>Reset</Button>
    </div>
  );
}

export function GlobalErrorBoundary({ children }: GlobalErrorBoundaryProps) {
  return <ErrorBoundary fallback={ErrorFallback}>{children}</ErrorBoundary>;
}
